import React from 'react';

const ChecklistIconIncomplete = (props) => (
  <svg width={12} height={12} viewBox="0 0 12 12" {...props}>
    <g fill={props.color || 'currentColor'}>
      <path d="M4.103 5.08a.75.75 0 0 0-1.084 1.036l2.475 2.585 5.966-5.965a.75.75 0 1 0-1.06-1.06l-4.882 4.88L4.103 5.08z" />
      <path d="M10.411 10.411H1.604V1.605h6.371a.75.75 0 0 0 0-1.5H.105V11.91H11.91V6a.75.75 0 0 0-1.5 0v4.411z" />
    </g>
  </svg>
);

export default ChecklistIconIncomplete;



// WEBPACK FOOTER //
// ./app/common/components/canonical-components/icons/ChecklistIconIncomplete.js